const state = {
  isDarkMode: localStorage.getItem('darkMode') === 'true' || false
};

const getters = {
  isDarkMode: state => state.isDarkMode
};

const mutations = {
  toggleDarkMode(state) {
    state.isDarkMode = !state.isDarkMode;
    localStorage.setItem('darkMode', state.isDarkMode);
    
    // Apply dark mode to body
    if (state.isDarkMode) {
      document.body.classList.add('dark-mode');
      document.body.classList.remove('light-mode');
    } else {
      document.body.classList.remove('dark-mode');
      document.body.classList.add('light-mode');
    }
  },
  
  setDarkMode(state, value) {
    state.isDarkMode = value;
    localStorage.setItem('darkMode', value);
    
    if (value) {
      document.body.classList.add('dark-mode');
      document.body.classList.remove('light-mode');
    } else {
      document.body.classList.remove('dark-mode');
      document.body.classList.add('light-mode');
    }
  }
};

const actions = {
  initializeDarkMode({ commit }) {
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode !== null) {
      commit('setDarkMode', savedMode === 'true');
    } else {
      // Default to light mode
      commit('setDarkMode', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
